import React from 'react';
import './index.scss';
import type { ISplitPaneProps } from './types';

/**
 * SplitPane 分栏组件
 *
 * 用于创建左右分栏布局，支持压缩左侧内容展开右侧侧边栏的交互模式
 *
 * @example
 * ```tsx
 * <SplitPane
 *   sidebarVisible={showSidebar}
 *   sidebar={<DetailPanel />}
 *   sidebarWidth="368px"
 * >
 *   <MainContent />
 * </SplitPane>
 * ```
 */
export default function SplitPane({
  children,
  sidebar,
  sidebarVisible,
  sidebarWidth = '360px',
  sidebarGap = '20px',
  position = 'right',
  animationDuration = 200,
  className,
}: ISplitPaneProps) {
  const baseClass = 'dbo-split-pane';
  const positionClass =
    position === 'left' ? '--position-left' : '--position-right';

  const style: React.CSSProperties & {
    '--sidebar-width': string;
    '--sidebar-gap': string;
    '--animation-duration': string;
  } = {
    '--sidebar-width':
      typeof sidebarWidth === 'number' ? `${sidebarWidth}px` : sidebarWidth,
    '--sidebar-gap':
      typeof sidebarGap === 'number' ? `${sidebarGap}px` : sidebarGap,
    '--animation-duration': `${animationDuration}ms`,
  };

  return (
    <div
      className={`${baseClass} ${positionClass} ${
        sidebarVisible ? '--sidebar-visible' : ''
      } ${className || ''}`}
      style={style}
    >
      {/* 左侧内容区（主内容） */}
      <div className={`${baseClass}__content`}>{children}</div>

      {/* 右侧侧边栏容器 */}
      {sidebar && <div className={`${baseClass}__sidebar`}>{sidebar}</div>}
    </div>
  );
}
